var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.docType == 'word')?_c('vue-office-docx',{staticStyle:{"height":"100vh"},attrs:{"src":_vm.docUrl},on:{"rendered":_vm.rendered}}):_c('vue-office-excel',{staticStyle:{"height":"100vh"},attrs:{"src":_vm.docUrl},on:{"rendered":_vm.rendered}})}
var staticRenderFns = []

export { render, staticRenderFns }